export default __webpack_public_path__ + "static/media/night.8bf8c074.hdr";